export const ANIMAL_ALERT_TYPES = ['Chaos!', 'Eeeek!', 'Get a room!'] as const;

export type AnimalAlertType = (typeof ANIMAL_ALERT_TYPES)[number];

export const ANIMAL_ALERT_COOLDOWN_MS = 180_000;
